var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-center mb-3"},[_vm._v("Mis alertas")]),_c('alertsTable',{attrs:{"alerts":_vm.procurementAlerts.alerts,"current_page":_vm.procurementAlerts.current_page,"total_pages":_vm.procurementAlerts.total_pages,"alert_type":'procurement'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }